import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Directives
import { KeyPressLineItemsDirective } from '@app/core/_base/layout/directives/key-press-line-items/key-press-line-items.directive';

const angularModules = [FormsModule, ReactiveFormsModule, CommonModule];

const directives = [KeyPressLineItemsDirective];

@NgModule({
  declarations: [...directives],
  exports: [...directives],
  imports: [...angularModules],
})
export class DirectiveV1Module {}
